import color from './colorThemes'

export default {
  id: 'boundsFill',
  source: 'bounds',
  type: 'fill',
  paint: {
    'fill-color': color.boundsFill,
    // 'fill-opacity': 0.05,
  },
}
